import React, {useState} from 'react';
import {ListAllLevelsLevelType} from '../../../types/TypesUserProfit';
import {useTranslation} from 'react-i18next';
import {formatNumber} from '../../../assets/utils/utils';
import ClientInfoPopup from '../../MyTeam/Components/ClientInfoPopup/ClientInfoPopup';
import styles from './LevelListElement.new.module.css';

type Props = {
	level: ListAllLevelsLevelType;
};

const LevelListElement: React.FC<Props> = ({level}) => {
	const [open, setOpen] = useState(false);
	const [clientInfo, setClientInfo] = useState<number | null>(null);
	const {t} = useTranslation();

	const handleClickUser = (id: number) => {
		setClientInfo(id);
	};

	return (
		<>
			<div className={`${styles.levelItem} ${open ? styles.active : ''}`}>
				<div className={styles.levelHeader} onClick={() => setOpen(!open)}>
					<div className={styles.arrow}></div>
					<div className={styles.levelInfo}>
						<span className={styles.levelTitle}>
							{level?.level} {t('Рівень')}
						</span>
						<span className={styles.levelPercent}>{level?.percent}%</span>
					</div>
					<div className={styles.valuesContainer}>
						<div className={styles.value}>
							{formatNumber(level?.activity)} {t('балів')}
						</div>
						<div className={styles.divider}>/</div>
						<div className={styles.value}>
							{formatNumber(level?.check_points)} {t('бонусів')}
						</div>
					</div>
				</div>

				<div className={`${styles.usersList} ${open ? styles.open : ''}`}>
					{level?.children?.map((user: any) => {
						return (
							<div key={user.id || user.name} className={styles.userItem}>
								<div className={styles.userInfo}>
									<span className={styles.userQualification}>{user?.qlfc}</span>
									<button
										className={styles.userName}
										onClick={() => handleClickUser(user.id)}
									>
										{user?.name}
									</button>
									<span className={styles.userPercent}>{user?.percent}%</span>
								</div>
								<div className={styles.userValues}>
									<div className={styles.value}>
										{formatNumber(user?.activity)} {t('балів')}
									</div>
									<div className={styles.userDivider}>/</div>
									<div className={styles.value}>
										{formatNumber(user?.check_points)} {t('бонусів')}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>

			{clientInfo !== null && clientInfo !== 0 && (
				<ClientInfoPopup
					clientInfo={clientInfo}
					setClientInfo={setClientInfo}
				/>
			)}
		</>
	);
};

export default LevelListElement;

